import { ArrowLeft } from 'lucide-react';
import { useNavigate,useParams } from 'react-router-dom';

import { Button } from '@/components/ui/button';

import { useBatchCallDetailQuery } from '@/query/scheduler.query';

import { BatchCallDetailHeader } from './components/BatchCallDetailHeader';
import { BatchCallKpiCards } from './components/BatchCallKpiCards';
import { RecipientsTable } from './components/RecipientsTable';

export default function BatchCallDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: batchCall, isLoading } = useBatchCallDetailQuery(parseInt(id));

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!batchCall) {
    return (
      <div className="flex flex-col items-center justify-center h-full py-20 px-4">
        <div className="text-center space-y-4">
          <h2 className="text-2xl font-semibold">Batch Call Not Found</h2>
          <p className="text-muted-foreground">The batch call you're looking for doesn't exist.</p>
          <Button onClick={() => navigate('/batch-calls')}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Batch Calls
          </Button>
        </div>
      </div>
    );
  }

  const total = batchCall.totalRecipients;
  const completedCount = batchCall.completedRecipients;
  const pendingCount = batchCall.pendingRecipients;
  const failedCount = batchCall.failedRecipients;
  const completedPercentage = total > 0 ? Math.round((completedCount / total) * 100) : 0;
  const pendingPercentage = total > 0 ? Math.round((pendingCount / total) * 100) : 0;
  const failedPercentage = total > 0 ? Math.round((failedCount / total) * 100) : 0;

  return (
    <div className="flex flex-col gap-6 h-full">
      <BatchCallDetailHeader batchCall={batchCall} />
      <BatchCallKpiCards
        totalRecipients={batchCall.totalRecipients}
        completedCount={batchCall.completedRecipients}
        pendingCount={batchCall.pendingRecipients}
        failedCount={batchCall.failedRecipients}
        completedPercentage={completedPercentage}
        pendingPercentage={pendingPercentage}
        failedPercentage={failedPercentage}
      />
      <RecipientsTable batchCallId={parseInt(id)} />
    </div>
  );
}
